import React from "react";
import { CourseReadingResource } from "../../../../stores/CoursesStore/Types";
import { ActiveTab } from "../types";

interface Props {
  activeTab: ActiveTab;
  loading: boolean;
  resources: CourseReadingResource[];
}

const ResourceThumb = ({ resource }: { resource: CourseReadingResource }) => {
  if (resource.image_url) {
    return (
      <img
        className="res__thumb"
        src={resource.image_url}
        alt=""
        loading="lazy"
      />
    );
  }

  return (
    <div
      className="res__thumb"
      style={{ background: "#233dff" }}
      aria-hidden="true"
    >
      {resource.name
        .split(" ")
        .slice(0, 2)
        .map((word) => word[0])
        .join("")}
    </div>
  );
};

const Resource = ({ resource }: { resource: CourseReadingResource }) => (
  <article className="res">
    <ResourceThumb resource={resource} />
    <div className="res__body">
      <h3 className="res__title">{resource.name}</h3>
      <p className="res__desc">{resource.description}</p>
    </div>
    <div className="res__act">
      <a
        className="btn btn-outline"
        href={resource.target_url}
        target="_blank"
        rel="noopener"
      >
        Visit{" "}
        <svg aria-hidden="true">
          <use href="#ic-ext" />
        </svg>
      </a>
    </div>
  </article>
);

const ResourcesPanel = ({ activeTab, loading, resources }: Props) => (
  <section
    className="tabpanel"
    id="panel-resources"
    role="tabpanel"
    aria-labelledby="tab-resources"
    hidden={activeTab !== "resources"}
  >
    <h2
      className="visually-hidden"
      style={{ position: "absolute", left: "-9999px" }}
    >
      Resources
    </h2>
    <p className="res-intro">
      Books, podcasts and people worth your time if you want to go deeper. Most
      of these are not ours, which is rather the point.{" "}
      <em>Good ideas don't care who published them.</em>
    </p>

    {loading ? (
      <div className="ui active inverted dimmer">
        <div className="ui text loader">Loading</div>
      </div>
    ) : (
      <div className="res-list">
        {resources.map((resource) => (
          <Resource key={resource.id} resource={resource} />
        ))}
      </div>
    )}

    <p className="res-disclaimer">
      42courses is a participant in the Amazon Services LLC Associates
      Programme, an affiliate advertising programme designed to provide a means
      for sites to earn advertising fees by advertising and linking to{" "}
      <a href="https://www.amazon.com" target="_blank" rel="noopener">
        Amazon.com
      </a>
      .
    </p>
  </section>
);

export default ResourcesPanel;
